import { render, staticRenderFns } from "./UserCreationStep3.vue?vue&type=template&id=44966a83"
import script from "./UserCreationStep3.vue?vue&type=script&lang=ts"
export * from "./UserCreationStep3.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports